import type {ReactElement} from 'react'
import React from 'react'
import Eye from '../../icons/eye'
import {Field} from 'formik'
import { useRouter } from 'next/router'
interface Props {
  type: string
  name: string
  label: string
  sublabel?: string
  placeholder: string
  isError: any
  rows?: number
  error: any | undefined
  dir?: any
}
export default function TextArea({
  type,
  name,
  label,
  sublabel,
  isError,
  rows = 1,
  error,
  placeholder,
  dir
}: Props): ReactElement {
  const {locale} = useRouter();
  return (
    <>
      <div className="w-full" dir={dir}>
        <label
          htmlFor={name}
          className={`w-full ${locale === 'ar' ? 'text-right' : 'text-left'} block text-xs text-primary`}>
          {label}
        </label>
        <p className="text text-right font-light text-sm text-[#93A3B0CC] opacity-80">
          {sublabel}
        </p>
        <div className="relative">
          <Field
            as="textarea"
            rows={rows}
            className={`w-full placeholder:font-light placeholder:text-[#93A3B0CC] placeholder:opacity-80 mt-2 py-3 px-3 focus:ring-1 transition duration-200 focus:ring-black focus:border-transparent text-xs
                                rounded-md ${
                                  isError
                                    ? 'border-1 border-red'
                                    : 'border-1 border-gray-300'
                                } `}
            id={name}
            name={name}
            placeholder={placeholder}
          />
        </div>
      </div>
      <div className=" mt-1 text-right text-sm text-red-500 font-semibold">
        {error}
      </div>
    </>
  )
}
